import React from 'react';

import { observer } from 'mobx-react-lite';
import { WorkItemType } from 'stores/work_item_store';
import { api_post } from 'api/utils';


type WorkItemContextType = {
    complete: (
        identity: string,
        associated_uuid: string,
        completed: boolean
    ) => Promise<WorkItemType>;

}

export const WorkItemContext = React.createContext<WorkItemContextType>({
    complete: () => { throw 'Not Implemented' },
});


export const WorkItemProvider = observer(({ children }: { children: React.ReactNode }) => {

    const complete = async (
        identity: string,
        associated_uuid: string,
        completed: boolean
    ) => {
        const associated_type = associated_uuid.startsWith('co') ? 'collab' : 'request';
        return api_post('/work-item/complete', {
            identity,
            associated_type,
            associated_uuid,
            completed: completed ? 'yes' : 'no',
        }).then(async (response) => {
            if (response.ok) {
                return await response.json();
            }
            return null;
        });
    };

    const data = {
        complete,
    };

    return (
        <WorkItemContext.Provider value={data}>{ children }</WorkItemContext.Provider>
    );

});
